'use strict';

const { mapState } = require('vuex');
const damHelper = require('../../dam/dam-helper');
const ProductChoiceList = require('../products/product-choice-list/product-choice-list.vue');
const flyinId = 'bonusProductChoice';
const scrollHelper = require('../../modules/helpers/scroll');

module.exports = {
    computed: {
        ...mapState('bonusItems', ['resources', 'productsList'])
    },
    methods: {
        showBonusProductsFlyin() {
            scrollHelper.disableScroll();
            window.eventBus.$on('flyinClosed', (id) => {
                scrollHelper.enableScroll();
                if (flyinId === id) {
                    this.bonusProductPicked();
                }
            });
            window.eventBus.$emit('shouldOpenFlyin', {
                id: flyinId,
                content: ProductChoiceList,
                props: { resources: this.resources, products: this.productsList, onProductPicked: this.bonusProductPicked },
            });
        },
        bonusProductPicked(productId) {
            this.$store.dispatch('bonusItems/addBonusProductToBasket', productId || this.productsList[0].productID);
        },
        initImagesAndSlider() {
            damHelper.updateImages(document.getElementById('bonus-product-list'));
        }
    },
    mounted() {
        if (this.productsList && this.productsList.length) {
            this.showBonusProductsFlyin();
        }
    },
    watch: {
        productsList(productsList) {
            if (productsList && productsList.length) {
                this.showBonusProductsFlyin();
            }
        }
    }
};

